import { createContext, useRef, useState } from 'react';
import ConfirmationDialog from './ConfirmationDialog';

const ConfirmationContext = createContext({});

export function ConfirmationContextProvider({ children }) {

    const [isOpen, setIsOpen] = useState(false);
    const [options, setOptions] = useState({
        title: "Confirm?",
        content: "Are you sure?",
        onConfirm: () => {}
    });
    const promiseRef = useRef();

    const confirm = (options) => {
        return new Promise((resolve) => {
            setIsOpen(true);
            setOptions(options);
            promiseRef.current = {
                resolve
            }
        })
    }

    async function handleConfirm(e) {
        if (e && e.target) {
            e.target.disabled = true;
        }
        if (options.onConfirm) {
            await options.onConfirm();
        }
        if (promiseRef && promiseRef.current && promiseRef.current.resolve) {
            promiseRef.current.resolve(true);
        }
    }

    function closeDialog() {
        promiseRef.current.resolve(false);
        setIsOpen(false);
        setOptions({
            title: "",
            content: ""
        })
    }

    return (
        <ConfirmationContext.Provider
            value={{ confirm, closeDialog }}>
            { children }

            {
                isOpen &&
                <ConfirmationDialog
                    {...options}
                    onToggle={closeDialog}
                    onConfirm={handleConfirm}
                    onCancel={closeDialog} />
            }
        </ConfirmationContext.Provider>
    )
}

export default ConfirmationContext;